<template>
  <div class="borda">
    <ValidationObserver ref="observer">
      <v-row align="center" class="pt-6">
        <v-col cols="12" md="4" class="py-1">
          <div>Parâmetro:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <input-cadu disabled value="Iniciativa Institucional" />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Iniciativa Institucional:</div>
        </v-col>

        <v-col cols="12" md="6" class="py-1">
          <validation-provider name="area" mode="eager" rules="required" v-slot="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              :items="listaIniciativas.map((el) => el.nome)"
              v-model="iniciativaSelecionada.nome"
              @index="indexUnimed"
            />
          </validation-provider>
        </v-col>

        <v-col v-if="iniciativaSelecionada.id" class="py-1 pl-0" align-self="center">
          <button-rounded iconName="trash" :iconSize="16" @click="showDelete = true" />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Tooltip:</div>
        </v-col>

        <v-col cols="12" md="6">
          <input-cadu :onlyUpperCase="false" v-model="iniciativaSelecionada.descricao" />
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" md="4" class="py-1">
          <div>Ordem:</div>
        </v-col>

        <v-col cols="12" md="2" class="py-1">
          <validation-provider name="ordem" mode="eager" rules="required|max:150" v-slot="{ errors }">
            <input-cadu
              :disabled="!iniciativaSelecionada.id"
              onlyNumber
              :errorMessage="errors[0]"
              v-model="iniciativaSelecionada.ordem"
              max="150"
            />
          </validation-provider>
        </v-col>
      </v-row>
    </ValidationObserver>

    <v-row justify="end">
      <v-row justify="start">
        <v-col cols="auto" class="ml-4">
          <a style="color: #1492e6;" @click="showModalIniciativa = true"> + adicionar Iniciativa Institucional </a>
        </v-col>
      </v-row>

      <v-col cols="auto" class="py-1">
        <button-cadu @click="salvarIniciativa"> SALVAR </button-cadu>
      </v-col>
    </v-row>

    <overlay-loading v-model="loadingOverlay" />

    <error-modal v-model="showError" :errObj="errObj" />

    <SucessoModal
      :genericMessage="'Iniciativa institucional atualizada com sucesso'"
      :showSucess="showSucess"
      @close="fecharModal"
    />

    <IniciativaModal @att="atualizarModal" ref="modalIniciativa" v-model="showModalIniciativa" />

    <ExcluirModal
      text="Tem certeza que deseja excluir essa iniciativa?"
      :showDelete="showDelete"
      @close="showDelete = false"
      @confirmDelete="removeIniciativa()"
    />
  </div>
</template>

<script>
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'
import ErrorMixin from '@/Mixins/ErrorMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import IniciativaModal from './Shared/IniciativaModal'

export default {
  mixins: [ErrorMixin],

  components: {
    ValidationObserver,
    ValidationProvider,
    IniciativaModal
  },

  data() {
    return {
      parametro: '',
      status: false,
      config: '',
      loadingOverlay: false,
      editar: true,
      showSucess: false,
      parametrosGerais: '',
      listaIniciativas: [],
      iniciativaSelecionada: {
        nome: '',
        id: '',
        descricao: '',
        ordem: ''
      },
      ordem: '',
      showModalIniciativa: false,
      showDelete: false
    }
  },

  async created() {
    this.parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
    await this.loadingFunc(this.getIniciativas())
  },

  methods: {
    async atualizarModal(input) {
      await this.loadingFunc(this.getIniciativas())
      await this.$nextTick

      this.iniciativaSelecionada.nome = input.toUpperCase()
    },
    async loadingFunc(...func) {
      this.loadingOverlay = true
      await Promise.all(func).finally(() => {
        this.loadingOverlay = false
      })
    },
    async promiseGeneric(className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    indexUnimed(index) {
      this.iniciativaSelecionada.id = index !== null && index > -1 ? this.listaIniciativas[index].id : ''
      if (this.iniciativaSelecionada.id) {
        this.iniciativaSelecionada.nome = this.listaIniciativas[index].descricao
        this.iniciativaSelecionada.descricao = this.listaIniciativas[index].descricao
        this.iniciativaSelecionada.ordem = this.listaIniciativas[index].ordem
      } else {
        this.iniciativaSelecionada.nome = ''
        this.iniciativaSelecionada.descricao = ''
        this.iniciativaSelecionada.ordem = ''
      }
    },
    async getIniciativas() {
      const res = await this.promiseGeneric(this.parametrosGerais, 'getAllIniciativasInstitucionais')
      this.listaIniciativas = res.data
    },
    async salvarIniciativa() {
      const valid = await this.$refs.observer.validate()

      if (!valid) return
      await this.loadingFunc(
        this.promiseGeneric(
          this.parametrosGerais,
          'putIniciativaInstitucional',
          this.formData,
          this.iniciativaSelecionada.nome,
          this.iniciativaSelecionada.descricao,
          this.iniciativaSelecionada.id,
          this.iniciativaSelecionada.ordem
        )
      )
      this.genericMessage = 'Iniciativa institucional atualizada com sucesso'
      this.showSucess = true
      this.atualizarModal()
    },
    fecharModal() {
      this.showSucess = false
    },
    async removeIniciativa() {
      const obj = {
        nome: this.iniciativaSelecionada.nome,
        descricao: this.iniciativaSelecionada.descricao,
        id: this.iniciativaSelecionada.id,
        ordem: this.iniciativaSelecionada.ordem
      }

      await this.parametrosGerais
        .deleteIniciativaInstitucional(obj)
        .then(async () => await this.loadingFunc(this.getIniciativas()))
        .finally(() => {
          this.loadingOverlay = false
          this.showDelete = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.borda
  border: 1px solid #00995d
  border-radius: 10px
  padding: 10px
</style>
